/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [delete-post-dialog.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 24.02.20, 17:01
 */
import moment from 'moment';
import React from 'react';
import {useDispatch} from 'react-redux';
import {asyncDeletePost} from "../../../actions";
import {localDeleteMedia} from "../../../actions/spaces";
import {useLanguage} from "../../configuration/configuration";
import DialogBox from "../dialog-box";
import {useAuthorization} from "../../../selectors";
import {showVisibleImages} from "../../../actions/image-handler";
import {notify} from "../../notifications/notify";

const DeletePostDialog = ({post, setOpen}) => {
    const {principalUsername} = useAuthorization();
    const Lang = useLanguage();
    const dispatch = useDispatch();

    const deletePost = (event) => {
        event.preventDefault();
        dispatch(asyncDeletePost(principalUsername, post.id, post => {
                dispatch(localDeleteMedia(post.media || []));
                notify(Lang.dialog.deletePost.info(post.user.fullname));
                showVisibleImages();
            })
        );
    };

    return <div className='delete-post-dialog'>
        <DialogBox isOpen={true}
                   setIsOpen={() => setOpen(false)}
                   title={Lang.dialog.deletePost.title}
                   action={Lang.dialog.deletePost.actions.delete}
                   callback={deletePost}>

            <div className='delete-post-dialog-content mt-4'>
                {Lang.dialog.deletePost.subtitle(post.user.fullname, moment(post.created).fromNow())}
                <div className='delete-post-dialog-warning mt-2'>
                    {Lang.dialog.deletePost.warning}
                </div>
            </div>
        </DialogBox>

    </div>
};

export default DeletePostDialog;
